import moment from 'moment';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

export interface PricePackagePeriodCellProps {
    start: string;
    finish: string;
}

const BLOCK = 'grid-price-package-period-cell';

export class GridPricePackagePeriodCell extends React.PureComponent<PricePackagePeriodCellProps> {
    render() {
        const { start, finish } = this.props,
            from = moment(start)
                .format('DD.MM.YYYY')
                .toString(),
            to = moment(finish)
                .format('DD.MM.YYYY')
                .toString();

        return (
            <div className={Bem.cls(BLOCK)}>
                {from} &mdash; {to}
            </div>
        );
    }
}
